import { useCallback, useEffect, useState } from "react";
import { topicApi } from "@/entities/chat/api/chatApi";
import { getUserIdFromToken } from "@/shared/lib/token";
import { CHAT_READ_EVENT, hasUnread, loadReadState } from "./readState";

/**
 * Conversas por ler de um âmbito ('all' ou o id da obra), para contadores fora
 * do chat (menu da obra). Atualiza ao ler uma conversa e ao voltar à janela.
 */
export function useUnreadTopics(scope: string | undefined): number {
    const [count, setCount] = useState(0);

    const refresh = useCallback(async () => {
        if (!scope) return;
        try {
            const topics = await topicApi.getUserTopics(scope === "all" ? undefined : scope);
            const userId = getUserIdFromToken() ?? "";
            const lastRead = loadReadState();
            setCount(
                (topics || []).filter(
                    (t) => t.type !== "TICKET" && t.type !== "CALL_ROOM" && (t.unread ?? hasUnread(t.lastMessage, lastRead[t.id], userId))
                ).length
            );
        } catch {
            // Sem contador quando o chat não responde; o menu continua a funcionar.
        }
    }, [scope]);

    useEffect(() => {
        refresh();
        window.addEventListener(CHAT_READ_EVENT, refresh);
        window.addEventListener("focus", refresh);
        return () => {
            window.removeEventListener(CHAT_READ_EVENT, refresh);
            window.removeEventListener("focus", refresh);
        };
    }, [refresh]);

    return count;
}
